module.exports = __webpack_public_path__ + "static/media/isotipo.621ef745.svg";